import React from 'react';
import cn from 'classnames';
import elementType from 'react-prop-types/lib/elementType';
import { prefix, bsClass, splitBsProps } from './utils/bootstrapUtils';
import { PanelContext } from '../Panel/PanelContext';
class PanelHeading extends React.Component {
  render() {
    const {
      children,
      className,
      componentClass: Component,
      ...props
    } = this.props;
    const {
      headingId,
      bsClass: _bsClass
    } = this.context || {};
    const [bsProps, elementProps] = splitBsProps(props);
    bsProps.bsClass = _bsClass || bsProps.bsClass;
    if (headingId) {
      elementProps.role = elementProps.role || 'tab';
      elementProps.id = headingId;
    }
    return /*#__PURE__*/React.createElement(Component, Object.assign({}, elementProps, {
      className: cn(className, prefix(bsProps, 'heading'))
    }), children);
  }
}
PanelHeading.defaultProps = {
  componentClass: 'div'
};
PanelHeading.contextType = PanelContext;
export default bsClass('panel', PanelHeading);